import styled from 'styled-components';
import { getColorAlias, getFontSize } from '../../../../utils/index.js';

const Wrapper = styled.div `
  min-width: 175px;
  font-family: ${(props) => props.theme.font.familyPrimary};
  color: ${getColorAlias('contentDefault')};
  ${getFontSize('size16')};
`;
const IconWrapper = styled.div `
  margin-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    fill: ${(props) => getColorAlias(props.disabled ? 'contentDisabled' : 'contentDefault')};
  }
`;

export { IconWrapper, Wrapper };
